document.addEventListener("DOMContentLoaded", () => {
  const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((video) => {
        if (video.isIntersecting) {
          Array.from(video.target?.children).forEach((item) => {
            if (typeof item.tagName === "string" && item.tagName === "SOURCE") {
              item.src = item.dataset.src;
            }
          })

          if (video.target.dataset.src) {
            video.target.src = video.target.dataset.src;
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach((lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
